import React from "react";
import { DatePicker } from "@heroui/react";
import { parseDate } from "@internationalized/date";
import { I18nProvider } from "@react-aria/i18n";

const DateInput = ({
    label,
    value,
    onChange,
    isReadOnly = false,
    className = "max-w-[284px]",
    locale = "es-ES",
    ...props
}) => {
    // Función para convertir string de fecha a objeto CalendarDate
    const parseDateValue = (dateString) => {
        if (!dateString) return null;
        
        try {
            // Si la fecha viene con timestamp, extraer solo la parte de fecha
            const dateOnly = dateString.split("T")[0];
            return parseDate(dateOnly);
        } catch (error) {
            console.warn("Error parsing date:", dateString, error);
            return null;
        }
    };

    // Manejador de cambio de fecha
    const handleDateChange = (newValue) => {
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <I18nProvider locale="es-CL">
            <DatePicker
                className={className}
                label={label}
                onChange={handleDateChange}
                value={parseDateValue(value)}
                locale={locale}
                isReadOnly={isReadOnly}
                {...props}
            />
        </I18nProvider>
    );
};

export default DateInput; 